module.exports = __webpack_public_path__ + "static/media/header-960.222c9f1f.jpg";